import { Observable } from "rxjs";
import { RecentData } from "@app/core/recent-data/domain/model/recent-data";

export abstract class RecentDataRepo {
  /**
   * Get the recent data of the user.
   * @param token
   */
  abstract getRecentData(
    club_limit: number,
    token: string
  ): Observable<RecentData>;
}
